import React from "react"

export function OilsGradientIcon({ h, w, className = "" }: { h?: number; w?: number; className?: string }) {
  return (
    <svg width={w} height={h} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.35844 3.52L1.37284 13.628C0.958841 14.4671 0.765611 15.398 0.811406 16.3326C0.857201 17.2672 1.14051 18.1746 1.63456 18.9693C2.12861 19.7639 2.8171 20.4195 3.63498 20.8741C4.45286 21.3287 5.37313 21.5672 6.30884 21.5672H17.6912C18.6269 21.5674 19.5472 21.3289 20.3651 20.8745C21.183 20.42 21.8715 19.7645 22.3656 18.9699C22.8597 18.1753 23.143 17.2678 23.1888 16.3333C23.2346 15.3987 23.0413 14.4679 22.6272 13.6288L17.6416 3.52C17.6292 3.49628 17.611 3.47607 17.5888 3.4612C17.5665 3.44633 17.5409 3.43728 17.5142 3.4349C17.4875 3.43251 17.4607 3.43685 17.4361 3.44753C17.4116 3.4582 17.3901 3.47487 17.3736 3.496L15.4672 6.0848C15.4505 6.10762 15.4403 6.13459 15.4377 6.16279C15.4352 6.191 15.4404 6.21936 15.4528 6.2448L19.7848 15.028C19.9615 15.3841 20.0444 15.7794 20.0255 16.1765C20.0066 16.5736 19.8866 16.9592 19.6769 17.2969C19.4673 17.6347 19.1748 17.9132 18.8273 18.1063C18.4798 18.2993 18.0888 18.4004 17.6912 18.4H6.30884C5.91197 18.4 5.52166 18.2989 5.17476 18.1061C4.82787 17.9133 4.53585 17.6352 4.32629 17.2982C4.11674 16.9612 3.99657 16.5763 3.97714 16.1799C3.95771 15.7835 4.03966 15.3887 4.21524 15.0328L8.54724 6.2472C8.55966 6.22176 8.56489 6.1934 8.56235 6.16519C8.55981 6.13699 8.54961 6.11002 8.53284 6.0872L6.62644 3.4976C6.6117 3.47794 6.59263 3.46195 6.57071 3.45085C6.54879 3.43975 6.52461 3.43385 6.50004 3.4336H6.48564C6.45889 3.43616 6.43321 3.44542 6.41098 3.46052C6.38875 3.47562 6.37068 3.49608 6.35844 3.52Z"
        fill="url(#paint0_linear_8468_26146)"
      />
      <path
        d="M12.0001 16.5864C12.4833 16.5864 12.9619 16.4912 13.4083 16.3063C13.8548 16.1213 14.2605 15.8503 14.6022 15.5086C14.9439 15.1668 15.215 14.7612 15.3999 14.3147C15.5849 13.8682 15.6801 13.3897 15.6801 12.9064C15.6801 11.1208 12.8713 5.432 12.5513 4.7888L12.0001 3.684L11.4489 4.7896C11.1289 5.4296 8.32007 11.1216 8.32007 12.9072C8.32028 13.8831 8.70809 14.8189 9.3982 15.5088C10.0883 16.1988 11.0242 16.5864 12.0001 16.5864Z"
        fill="url(#paint1_linear_8468_26146)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_8468_26146"
          x1="12"
          y1="21.5672"
          x2="12"
          y2="3.4336"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset="1" stopColor="#F36F4F" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8468_26146"
          x1="12.0001"
          y1="16.5864"
          x2="12.0001"
          y2="3.684"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FBB03B" />
          <stop offset="1" stopColor="#F36F4F" />
        </linearGradient>
      </defs>
    </svg>
  )
}
